module.exports = __webpack_public_path__ + "static/media/murugappa_logo1.cf6c36a6.png";